import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { constants } from "@lib/constants";

const initialState = {
  allScripts: [],
  allScriptsLoading: false,
  scriptDetails: null,
  scriptLoading: false,
  error: null,
};

// 🔹 Fetch all scripts
export const fetchScripts = createAsyncThunk(
  "scriptReducer/fetchScripts",
  async ({ axiosGet }, thunkAPI) => {
    try {
      const response = await axiosGet(`${constants.LIST_SCRIPTS}`);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// 🔹 Fetch single script
export const fetchScriptDetails = createAsyncThunk(
  "scriptReducer/fetchScriptDetails",
  async ({ axiosGet, id }, thunkAPI) => {
    try {
      const response = await axiosGet(`${constants.GET_SCRIPT}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const scriptReducer = createSlice({
  name: "scriptReducer",
  initialState,
  reducers: {
    clearScriptDetails: (state) => {
      state.scriptDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScripts.pending, (state) => {
        state.allScriptsLoading = true;
        state.error = null;
      })
      .addCase(fetchScripts.fulfilled, (state, action) => {
        state.allScripts = action.payload;
        state.allScriptsLoading = false;
      })
      .addCase(fetchScripts.rejected, (state, action) => {
        state.allScriptsLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchScriptDetails.pending, (state) => {
        state.scriptLoading = true;
        state.error = null;
      })
      .addCase(fetchScriptDetails.fulfilled, (state, action) => {
        state.scriptDetails = action.payload;
        state.scriptLoading = false;
      })
      .addCase(fetchScriptDetails.rejected, (state, action) => {
        state.scriptLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearScriptDetails } = scriptReducer.actions;
export default scriptReducer.reducer;
